import {Module} from 'vuex'
import {PreheadersState, RootState} from '@/types/store/states'

const store: Module<PreheadersState, RootState> = {
  namespaced: true,
  state: {
    preheaders: [
      /* {
        bgColor: '#3268A6',
        textColor: '#fff',
        message: '',
        isShow: true,
        ref: 'beta'
      } */
    ]
  },
  getters: {
    getAll: (state) => {
      return state.preheaders
    }
  },
  mutations: {
    close: (state, index) => {
      state.preheaders[index].isShow = false;
    },
    closeAll: (state) => {
      for (let preh of state.preheaders) {
        preh.isShow = false;
      }
    },
    update: (state, obj) => {
      let i = -1;
      for (let preh of state.preheaders) {
        i++;
        for (let param in obj.params) {
          if (preh.ref === obj.ref) {
            // @ts-ignore
            state.preheaders[i][param] = obj.params[param];
            break;
          }
        }
      }
    },
    add: (state, obj) => {
      state.preheaders.push({
        bgColor: obj.bgColor || 'rgb(254, 237, 194)',
        textColor: obj.textColor || 'rgb(230, 164, 51)',
        message: obj.message,
        inner: obj.inner || false,
        ref: 'default',
        isShow: true
      })
    }
  }
}

export default store